module.exports = __webpack_public_path__ + "img/logo_transparent.2ae07ec1.png";